/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ReportsOverviewIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 34 26"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinecap="round" strokeLinejoin="round">
      <rect x="0.666666667" y="0.666666667" width="30.6666667" height="22.6666667" />
      <rect x="3.33333333" y="3.33333333" width="25.3333333" height="17.3333333" />
      <path d="M7.33333333,18 L7.33333333,15.3333333" />
      <path d="M10,18 L10,11.3333333" />
      <path d="M12.6666667,18 L12.6666667,14" />
      <path d="M15.3333333,18 L15.3333333,15.3333333" />
      <path d="M23.3333333,18 L23.3333333,8.66666667" />
      <path d="M20.6666667,18 L20.6666667,12" />
      <path d="M18,18 L18,6" />
    </g>
  </svg>
);

export default ReportsOverviewIcon;
